import { atom } from "@reatom/framework";

export const depositCreditsModalOpen = atom(false, "depositCreditsModalOpen");
